import baseTheme from '../../theme/baseTheme';
var MuiFormControlLabel = {
    root: {
        marginLeft: 0,
    },
    label: {
        // disables the negative margin from Typography, which was applied due to
        // Overpass being poorly made. Remove if Overpass fix finally gets released.
        marginBottom: 0,
        fontSize: baseTheme.typography.pxToRem(14),
    },
};
export default MuiFormControlLabel;
//# sourceMappingURL=MuiFormControlLabel.js.map